export interface Exercise {
  id: string;
  name: string;
  category: string;
}

export type DuelOpponent = {
  id: string;
  handle: string | null;
  display_name: string | null;
  avatar_url: string | null;
  gym_id?: string | null;
};

export type Step = 'templates' | 'opponent' | 'type' | 'details' | 'review';
export type DuelType = 'pr' | 'volume' | '1rm' | 'consistency' | 'strength';

export const DURATIONS = [
  { label: '24h', hours: 24 },
  { label: '3 Days', hours: 72 },
  { label: '1 Week', hours: 168 },
] as const;

export const CATEGORIES = [
  { id: 'legs', name: 'Legs' },
  { id: 'arms', name: 'Arms' },
  { id: 'chest', name: 'Chest' },
  { id: 'shoulders', name: 'Shoulders' },
  { id: 'back', name: 'Back' },
  { id: 'core', name: 'Core' },
  { id: 'full_body', name: 'Full Body' },
] as const;
